import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiTableHead-root': {
			backgroundColor: '#fff',
		},
	},
	cellStyle: {
		width: '7.25rem',
	},
}));
